<template>
    <div class="site-panel" v-if="site">
        <v-row class="no-frame">
            <v-col class="main-first-col modal-tab no-border">
                <c-site-contract-lim
                    :unit-id  = "site.id"
                    :unit     = "site"
                    :contract = "limContract"
                />
            </v-col>
            <v-col class="main-middlle-col modal-tab no-border">
                <v-row class="no-frame">
                    <c-site-contract-mnt
                        :unit-id  = "site.id"
                        :unit     = "site"
                        :contract = "mntContract"
                    />
                </v-row>
            </v-col>
            <v-col class="main-middlle-col modal-tab no-border">
                <v-row class="no-frame">
                    <c-site-contract-esc
                        :unit-id  = "site.id"
                        :unit     = "site"
                        :contract = "escContract"
                    />
                </v-row>
            </v-col>
            <v-col class="main-last-col modal-tab no-border">
                <v-row class="no-frame">
                    <c-site-contract-zus
                        :unit-id  = "site.id"
                        :unit     = "site"
                        :contract = "zusContract"
                    />
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import CSiteContractLim from "@/modules/msd/company/contract/components/controls/lim/CSiteContractLim.vue";
import CSiteContractMnt from "@/modules/msd/company/contract/components/controls/mnt/CSiteContractMnt.vue";
import CSiteContractEsc from "@/modules/msd/company/contract/components/controls/esc/CSiteContractEsc.vue";
import CSiteContractZus from "@/modules/msd/company/contract/components/controls/zus/CSiteContractZus.vue";

export default {
    name: "TSiteContracts",
    components: {
        CSiteContractLim,
        CSiteContractMnt,
        CSiteContractEsc,
        CSiteContractZus,
    },

    props: {
        site: {

        },
    },

    computed: {
        isLiftmanagement () {
            return this.site && this.site.liftmanagement;
        },

        limContract () {
            if (!this.isLiftmanagement) {
                return null;
            }

            return this.site.liftmanagement.contract;
        },

        mntContract () {
            if (!this.isLiftmanagement) {
                return null;
            }

            return this.site.liftmanagement.mntContract;
        },


        escContract () {
            if (!this.isLiftmanagement) {
                return null;
            }

            return this.site.liftmanagement.escContract;
        },

        zusContract () {
            if (!this.isLiftmanagement) {
                return null;
            }

            return this.site.liftmanagement.zusContract;
        },
    }
}
</script>

<style scoped>

</style>